<template>
  <div class="items">
    <ul>
      <li v-for="(item, index) in items" :key="index">
        <button
          class="item"
          :class="{ 'is-selected': index === selectedIndex }"
          @click="selectItem(index)"
        >
          {{ item.value }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },

    command: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      selectedIndex: 0,
    };
  },

  watch: {
    items() {
      this.selectedIndex = 0;
    },
  },

  methods: {
    onKeyDown({ event }) {
      if (event.key === "ArrowUp") {
        this.upHandler();
        return true;
      }

      if (event.key === "ArrowDown") {
        this.downHandler();
        return true;
      }

      if (event.key === "Enter") {
        this.enterHandler();
        return true;
      }

      return false;
    },

    upHandler() {
      this.selectedIndex =
        (this.selectedIndex + this.items.length - 1) % this.items.length;
      this.$el.scrollTop =
        (this.$el.firstChild.clientHeight / this.items.length) *
        this.selectedIndex;
    },

    downHandler() {
      this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
      this.$el.scrollTop =
        (this.$el.firstChild.clientHeight / this.items.length) *
        this.selectedIndex;
    },

    enterHandler() {
      this.selectItem(this.selectedIndex);
    },

    selectItem(index) {
      const item = this.items[index];
      if (item) {
        this.command({ id: item.value, "data-user": item.key });
      }
    },
  },
};
</script>

<style lang="scss">
.items {
  position: relative;
  border-radius: 0.25rem;
  background: var(--v-cardSurface-base);
  color: var(--v-primaryText-base);
  //   overflow: hidden;
  font-size: 0.9rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1), 0px 10px 20px rgba(0, 0, 0, 0.1);
  overflow: auto;
  max-height: 200px;
}

.item {
  display: block;
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 0.2rem 0.5rem;

  &.is-selected,
  &:hover {
    color: var(--v-primary-base);
    background: var(--v-backgroundShadow-base);
  }
}
</style>
